module.exports = __webpack_public_path__ + "static/media/face.b15cb8e8.svg";